/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Questions from './Questions/index'
import React from 'react'
import TysiaCard from 'DesignSystem/TysiaCard/index'
import TysiaCardHeader from 'DesignSystem/TysiaCard/TysiaCardHeader/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Medical/Content/PreviousQuestions/Content"
  
}) {
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
let previousQuestionsValueData = fromData.useDataFormat({ viewPath,
context: 'previous_questions',
format: fromHelpers.getLastModified,
})
  return (<React.Fragment
>
<TysiaCard
  viewPath={`${viewPath}/TysiaCard`}
>
{childProps => (
<React.Fragment>
<TysiaCardHeader
{...childProps}
  viewPath={`${viewPath}/TysiaCardHeader`}
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 marginTop={0.1}
 marginBottom={0.1}
 text="Previous Questions"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral700}
 text="Questions answered by this patient on a previous Medical Form"
/>
</div>
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 lineHeight="28px"
 color={dtColorsNeutral700}
 data="previous_questions"
 format="helpers.js getLastModified"
 text={previousQuestionsValueData}
/>
</React.Fragment>
)}
</TysiaCardHeader>
<Questions
{...childProps}
  viewPath={`${viewPath}/Questions`}
/>
</React.Fragment>
)}
</TysiaCard>
{children}
</React.Fragment>)
}